import {createContext} from 'react'

export const MembersAuthContext = createContext({isMembersAuthPage: false})
